import { render, staticRenderFns } from "./MediaSwiper.vue?vue&type=template&id=35474dba&scoped=true&"
import script from "./MediaSwiper.vue?vue&type=script&lang=js&"
export * from "./MediaSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MediaSwiper.vue?vue&type=style&index=0&id=35474dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35474dba",
  null
  
)

export default component.exports